import React from 'react';
import '../CSS/style/style.css';

const RoomCarousel = ({ images, idPrefix }) => {
    return (
        <div id={`carousel-${idPrefix}`} className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                {images.map((img, idx) => (
                    <div key={img.seq} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                        <img
                            src={`resource/img/${img.title}/${img.img}`}
                            className="d-block w-100"
                            alt={`${img.title}_${img.seq}`}
                            style={{ objectFit: 'cover', maxHeight: '700px' }}
                        />
                    </div>
                ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${idPrefix}`} data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true" />
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${idPrefix}`} data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true" />
                <span className="visually-hidden">Next</span>
            </button>
            <div className="carousel-indicators" style={{ position: 'static', marginTop: '10px' }}>
                {images.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        data-bs-target={`#carousel-${idPrefix}`}
                        data-bs-slide-to={idx}
                        className={idx === 0 ? 'active' : ''}
                        aria-current={idx === 0 ? 'true' : undefined}
                        aria-label={`Slide ${idx + 1}`}
                        style={{backgroundColor:'#000'}}
                    />
                ))}
            </div>
        </div>
    );
};

export default RoomCarousel;
